import React from 'react';
import { Inspector, Form } from '@bynder/design-system';
import { useCollectionWidgetMutations } from '../../../../mutations/widgets/collections';
import { EditCollectionPropsType } from '../../../../types/widgets/collections';
import { CollectionWidget } from '../../../../types/widgets/collections';
import { WIDGET_TYPE } from '../../../../types';
import { WidgetSettingsHeader } from '../../Styles';
import CollectionRedirectSettings from './CollectionWidgetSettings/CollectionRedirectSettings';
import CollectionDownloadSettings from './CollectionWidgetSettings/CollectionDownloadSettings';
import CollectionPicker from './CollectionWidgetSettings/CollectionPicker';
import LayoutGridSelector from './CollectionWidgetSettings/LayoutGridSelector';
import AssetsShownSelector from './CollectionWidgetSettings/AssetsShownSelector';
import CollectionTitleSelector from './CollectionWidgetSettings/CollectionTitleSelector';
import CollectionAssetCount from './CollectionWidgetSettings/CollectionAssetCount';
import CollectionTitle from './CollectionWidgetSettings/CollectionTitle';
import CollectionAssetTitle from './CollectionWidgetSettings/CollectionAssetTitle';
import { isDevelopment } from '../../../../constants/app';
import CustomCssStyleEditor from '../CustomCSSEditor';
import { useActiveWidget } from '../../../../queries/guides';

export const CollectionWidgetSettings: React.FC = () => {
  const widget = useActiveWidget() as CollectionWidget;
  const { editCollectionWidget, editStyle } = useCollectionWidgetMutations();

  const onEditCollection = (collectionOptions: EditCollectionPropsType) => {
    editCollectionWidget.mutate({
      collectionId: widget.collectionId,
      ...collectionOptions,
    });
  };

  const handleChange = <T extends keyof EditCollectionPropsType>(
    key: T,
    value: EditCollectionPropsType[T],
  ) => {
    onEditCollection({
      collectionId: widget.collectionId,
      ...widget.collectionSettings,
      ...{ [key]: value },
    });
  };

  const handleStyleChange = (style: string) => {
    editStyle.mutate({ style });
  };

  return (
    <>
      <WidgetSettingsHeader widgetType={WIDGET_TYPE.COLLECTION} />
      <CollectionPicker handleChange={handleChange} />
      <Form>
        <Form.Row>
          <LayoutGridSelector handleChange={handleChange} />
          <AssetsShownSelector handleChange={handleChange} />
        </Form.Row>
      </Form>
      <Inspector.Divider />
      <CollectionTitle
        style={widget.style.stylesheet}
        handleStyleChange={handleStyleChange}
      />
      <Inspector.Divider />
      <CollectionAssetCount
        style={widget.style.stylesheet}
        handleStyleChange={handleStyleChange}
      />
      <Inspector.Divider />
      <CollectionAssetTitle
        style={widget.style.stylesheet}
        handleStyleChange={handleStyleChange}
      />
      <Inspector.Divider />
      <CollectionTitleSelector handleChange={handleChange} />
      <CollectionDownloadSettings handleChange={handleChange} />
      <CollectionRedirectSettings handleChange={handleChange} />
      {isDevelopment && (
        <CustomCssStyleEditor
          style={widget.style.stylesheet}
          handleChange={() => {
            editStyle.mutate({ style: '' });
          }}
        />
      )}
    </>
  );
};
